import type { HighlightResult } from "@/features/candidate/lib/highlights";

/** Remove highlights hidden by org compliance settings (ids match ``HighlightType``). */
export function filterHighlightsByComplianceSettings(
  highlights: HighlightResult[],
  hiddenProfileHighlightIds: readonly string[] | null | undefined,
): HighlightResult[] {
  if (!hiddenProfileHighlightIds?.length) {
    return highlights;
  }
  const hidden = new Set(hiddenProfileHighlightIds);
  return highlights.filter((highlight) => !hidden.has(highlight.type));
}
